import { CommonModule } from '@angular/common';
import { booleanAttribute, ChangeDetectionStrategy, Component, computed, HostBinding, input } from '@angular/core';
import { GalaxyAvatarModule } from '@vendasta/galaxy/avatar';

import { TranslateModule } from '@ngx-translate/core';
import { ChatSourceId } from '@vendasta/galaxy/chat-composer';
import { ChatMessageComponent } from '../chat-message/chat-message.component';

export type WidthPreset = 'default' | 'center';

@Component({
  selector: 'glxy-chat-message-group',
  imports: [CommonModule, GalaxyAvatarModule, ChatMessageComponent, TranslateModule],
  templateUrl: './chat-message-group.component.html',
  styleUrls: ['./chat-message-group.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChatMessageGroupComponent {
  @HostBinding('class') class = 'glxy-chat-message-group';

  readonly messageAlignment = input<WidthPreset>('default');
  readonly type = input<'sent' | 'received' | 'generated'>('received');
  readonly messageFrom = input('');
  readonly messageMetadata = input<string | undefined>();
  readonly profileIcon = input<string | undefined>();
  readonly profilePicUrl = input<string | undefined>();
  readonly profileSVGIcon = input<string | undefined>();
  readonly profileBackgroundColor = input<string | undefined>();
  readonly profileSourceIconName = input<ChatSourceId | undefined>();
  readonly showProfilePic = input<boolean | 'auto'>('auto');
  readonly sentFromYou = input(false, { transform: booleanAttribute });
  readonly isTyping = input(false, { transform: booleanAttribute });
  readonly showReceivedMessageMetadata = input(false, { transform: booleanAttribute });
  readonly hideAvatar = input(false, { transform: booleanAttribute });

  protected readonly shouldShowProfilePic = computed(() => {
    if (this.hideAvatar()) return false;
    return (
      this.showProfilePic() === true ||
      (this.type() === 'received' && this.showProfilePic() !== false) ||
      (this.type() === 'sent' && !this.sentFromYou() && this.showProfilePic() !== false)
    );
  });
}
